import React from 'react';
import { LOGO_URL } from './constants';
export function Footer() {
  return <footer className="bg-navy px-4 py-12 text-center text-white" data-id="element-101" data-mp="3gf942tsw627w">
      <div className="mx-auto max-w-lg" data-id="element-102" data-mp="3ggk7utmc79z0">
        <img src={LOGO_URL} alt="Karito Educa" className="mx-auto h-14 w-auto brightness-0 invert" data-id="element-103" data-mp="32o48c2sn9u2u" />
        <p className="mt-5 font-display text-lg font-black" data-id="element-104" data-mp="36q90ex3g2ind">
          🗓️ Método Domingo Libre™
        </p>
        <p className="mt-1 text-sm text-white/60" data-id="element-105" data-mp="3ufjz8918i2yv">Por Karito Educa</p>
        <p className="mx-auto mt-4 max-w-sm text-sm italic text-white/70" data-id="element-106" data-mp="37o6cv1anxdd">
          Porque 240 horas de tu vida al año merecen un sistema mejor.
        </p>
        <p className="mt-8 text-xs text-white/40" data-id="element-107" data-mp="3lgos8uqd8oui">
          © {new Date().getFullYear()} Karito Educa. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}